import { render, staticRenderFns } from "./AdminCalendar.vue?vue&type=template&id=7436d5e8&"
import script from "./AdminCalendar.vue?vue&type=script&lang=js&"
export * from "./AdminCalendar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports